import clsx from "clsx";
import { formatClassificationValue } from "../../utils/textFormatting";
import { PlanningClassification } from "../../types";

export interface ClassificationBadgeProps {
  classification: PlanningClassification;
}

export const ClassificationBadge = ({ classification }: ClassificationBadgeProps) => (
  <div
    title={formatClassificationValue(classification)}
    className={clsx(
      "w-5 h-5 rounded-full text-sm font-medium text-white flex items-center justify-center cursor-default select-none",
      {
        "bg-[#DC3964]": classification === PlanningClassification.RESIDENTIAL,
        "bg-marketing-purple-600": classification === PlanningClassification.COMMERCIAL,
        "bg-linear-to-tr from-[#862BDE] to-[#DC2626]": classification === PlanningClassification.MIXED_USE,
        "bg-platform-blue-400": classification === PlanningClassification.OTHER,
        "bg-blue-grey-400": classification === PlanningClassification.UNKNOWN,
      }
    )}
    style={{ WebkitPrintColorAdjust: "exact", printColorAdjust: "exact" }}
  >
    {classification.charAt(0).toUpperCase()}
  </div>
);
